import React from 'react';
import { scrollTo } from 'helper/utils';
import { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import { setData } from 'redux/actions/main';
import './index.scss';

export default function SideBar() {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const active = useSelector((state) => state.main.activePage, shallowEqual);
	const menu = [
		{
			id: 'livestream',
			path: '/',
			name: 'live stream',
		},
		{
			id: 'milestone',
			path: '/',
			name: 'viewer milestone',
		},
		{
			id: 'about',
			path: '/',
			name: 'about',
		},
		{
			id: 'teams',
			path: '/',
			name: 'teams',
		},
		{
			id: 'run',
			path: '/run',
			name: 'ffml run',
			redirect: true,
		},
	];
	const onClick = (data, e) => {
		e.preventDefault();
		const pathname = location.pathname;
		/** Redirect the page if pathname isn't same or is redirect button */
		if (pathname !== data.path || data.redirect) {
            dispatch(setData('activePage', data.id));
			history.push({
				pathname: data.path,
				search: data.redirect ? '' : `?pages=${data.id}`,
			});
			return;
		}
        scrollTo(`#${data.id}`);
	};
	useEffect(() => {
		if (location.pathname.includes('run')) {
			dispatch(setData('activePage', 'run'));
		}
	}, [location, dispatch]);
	if (location.pathname.includes('shared')) return <></>;
	return (
		<div className="sidebar">
			<div className="logo"></div>
			{menu.map((data) => {
				return (
					<NavLink
						isActive={() => active === data.id}
						onClick={(e) => onClick(data, e)}
						key={data.id}
						to={data.id}
						className={`menu menu-${data.id}`}
					>
						{data.name}
					</NavLink>
				);
			})}
		</div>
	);
}
